import { useState } from "react";
import { FieldValues } from "react-hook-form";
import { FieldErrors } from "react-hook-form/dist/types/errors";
import { useTranslation } from "next-i18next";
import { useToastStore } from "../../../config/store/toastStore";
import { BACKEND_URL } from "../../../../constants/env";
import { useJWT } from "../../../../hooks/react-query/useJWT";
import {
  queryClient,
  QueryKeys,
} from "../../../../hooks/react-query/query-client";

export function useProfile() {
  const [error, setError] = useState<string>("");
  const [processing, setProcessing] = useState<boolean>(false);
  const { i18n } = useTranslation("common");
  const { setToast } = useToastStore();
  const { jwt } = useJWT();

  async function editProfile(
    values: FieldValues,
    errors: FieldErrors<any>,
    closeModal: () => void
  ) {
    setError("");
    const formIsValid = Object.keys(errors).length === 0;
    if (formIsValid && jwt) {
      setProcessing(true);
      try {
        const response = await editUserOnServer(values, jwt);
        const responseStatus = response.status;
        switch (responseStatus) {
          case 422:
            setError(i18n.t("formErrors").toString());
            break;
          case 200:
            await queryClient.invalidateQueries(QueryKeys.USER);
            closeModal();
            setToast(i18n.t("success"), i18n.t("submit-success"));
            break;
          default:
            setError(i18n.t("submit-error").toString());
        }

        setProcessing(false);
      } catch (err) {
        console.log(err);
        setProcessing(false);
        setError(i18n.t("submit-error").toString());
      }
    } else {
      setError(i18n.t("formErrors").toString());
    }
  }

  async function editUserOnServer(form: FieldValues, authToken: string) {
    return await fetch(`${BACKEND_URL}/user/profile/edit`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        accessToken: authToken,
      },
      body: JSON.stringify(form),
    });
  }

  return {
    error,
    processing,
    editProfile,
  };
}
